var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      ref: "addToWishList",
      staticClass: "btn btn-link btn-sm text-muted",
      attrs: { "data-toggle": "tooltip", "data-placement": "top", title: "" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.switchState()
        },
      },
    },
    [
      _c("icon", {
        staticClass: "default-float",
        class: { "text-appearance text-danger": _vm.isVariationInWishList },
        attrs: { icon: "fa-nix icon-document", loading: _vm.isLoading },
      }),
      _vm._v(
        "\n    " +
          _vm._s(_vm.$translate("Ceres::Template.singleItemWishList")) +
          "\n"
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }